import { Spin } from 'antd';

const pageDefaultLoading = <Spin style={{ position: 'absolute', top: '50%', left: '50%' }} />;
export default pageDefaultLoading;
